module.exports = __webpack_public_path__ + "images/landing_get_it_from_google.26fba32f66992fcc6a8847f5988f1d72.png";